<template>
  <div class="page-body">
    <b-container fluid class='no-paddings'>
      <b-row>
        <b-col md="6">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search" />
            <b-input-group-append>
              <b-btn @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col md="6">
          <b-input-group prepend="Per page">
            <b-form-select :options="pageOptions" v-model="perPage" placeholder="5" />
          </b-input-group>
        </b-col>
      </b-row>
    </b-container>
    <br>
    <b-table :items="metrics" :filter="filter" :fields="fields" @filtered="onFiltered" :current-page="currentPage" :per-page="perPage" sort-by="name" @row-clicked="rowClicked">
    </b-table>
    <nav>
      <b-pagination size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
    </nav>
    <b-button class="table-scroll-btn" variant="primary" @click="hideTableScrollBtn = false" v-if="hideTableScrollBtn">Scroll Right For Additional Info <i class="fa fa-arrow-right" aria-hidden="true"></i></b-button>
  </div>
</template>
<script>
 export default {
   name: 'Metrics',

   data () {
     return {
       metrics: [],
       filter: null,
       perPage: 50,
       pageOptions: [ 5, 10, 15, 20, 50, 100, 200 ],
       totalRows: 0,
       currentPage: 1,
       hideTableScrollBtn: false,
       fields: [
         {key: 'id', thClass: 'd-none', tdClass: 'd-none', sortable: true},
         {key: 'name', sortable: true},
         {key: 'data_source', sortable: true},
         {key: 'service_class', sortable: true},
         {key: 'widget_types', sortable: true},
         {key: 'groupable_by_date', sortable: true},
         {key: 'table_columns', sortable: true}
       ]
     }
   },

   created () {
     this.loadMetrics()
     setTimeout(() => { this.scrollAlert() }, 1000)
   },

   methods: {
     rowClicked (item) {
       let id = item.id
       this.$router.push({name: 'Metric', params: {id}})
     },
     loadMetrics () {
       this.$http.get('/metrics?all_metrics=true')
         .then(function(response){
           this.metrics = response.data.data.map(function(data) {
             return {
               id: data.id,
               name: data.attributes.name,
               data_source: data.attributes.data_source,
               service_class: data.attributes.service_class,
               widget_types: data.attributes.widget_types,
               groupable_by_date: data.attributes.groupable_by_date,
               table_columns: data.attributes.table_columns.join(', ')
             }
           })
         }.bind(this))
     },

     onFiltered (filteredItems) {
       this.totalRows = filteredItems.length
       this.currentPage = 1
     },

     scrollAlert() {
      var table = document.getElementsByTagName('table')
      for (var i =0; i < table.length; i++) {
        if (table[i] !== null){
          if(table[i].offsetWidth > table[i].parentNode.offsetWidth){
            this.hideTableScrollBtn = true
          }
        }
      }
    }
   }
 }
</script>
<style scoped>
.table-scroll-btn{
  position: absolute;
  z-index: 12;
  right: 3%;
  bottom: 3%;
}
.page-body {
  overflow: auto;
}
.card .card-header {
  font-family: 'Cooper Hewitt Semibold';
  text-transform: uppercase;
  color: #3493B2;
  letter-spacing: 2px;
}
</style>
